module.exports = __webpack_public_path__ + "img/img_offreurs1.bcd53ce7.jpg";